import { render, staticRenderFns } from "./AdminSchedulesModalSubstitute.vue?vue&type=template&id=bbc013e8&scoped=true"
import script from "./AdminSchedulesModalSubstitute.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesModalSubstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc013e8",
  null
  
)

export default component.exports